.card {
  position: relative;
  background-color: var(--color-surface);
  border-radius: var(--radius-md);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);

  width: 300px;
  height: 280px;
  padding: 18px 24px 24px;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-4);

  cursor: pointer;
  transition:
    box-shadow 240ms ease,
    transform 240ms ease;
}

.card:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.28);
  transform: translateY(-1px);
}

.card:active {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.24);
  transform: translateY(0);
}

.bookmarkCard {
  position: relative;
  background-color: var(--color-surface);
  border-radius: var(--radius-md);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  padding: 18px 24px 24px;
  box-sizing: border-box;

  cursor: pointer;
  transition:
    box-shadow 240ms ease,
    transform 240ms ease;
}

.bookmarkCard:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.28);
  transform: translateY(-1px);
}

.bookmarkCard:active {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.24);
  transform: translateY(0);
}

.cardContent {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-3);
  height: 100%;
}

.bookmarkCardContent {
  display: flex;
  gap: var(--space-4);
}

.bookmarkCardText {
  text-align: left;
  align-content: center;
}

.bookmarkCardText p {
  text-align: left;
  margin-bottom: var(--space-1);
}

.bookmarkCardText h3 {
  text-align: left;
}

.cardTitle {
  font-size: var(--font-size-lg);
  font-weight: bold;
  color: #333;
  margin: 0;
  text-align: center;
  width: 100%;
  line-height: 1.2;
}

.cardLink {
  display: block;
  width: 150px;
  height: 150px;
  margin: 0;
}

.bookmarkCardImg {
  height: 150px;
  width: 150px;
  margin: 0;
  object-fit: cover;
}

.cardThumbnail {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
  margin: 0;
}

.cardSubtitle {
  font-size: var(--font-size-sm);
  font-family: var(--font-family-base);
  color: #666;
  text-align: center;
  margin: 0;
  width: 100%;
  line-height: 1.25;
}

.panelCardLink {
  display: block;
  width: 50%;
  overflow: hidden;
  border-radius: 8px;
}

.panelCardThumbnailContainer {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  width: 100%;
}

.panelCardThumbnail {
  width: 100%;
  height: 100%;
  object-fit: cover;
  aspect-ratio: 1 / 1;
  border-radius: 8px;
}

.cardBookmarkButton {
  position: absolute;
  top: 8px;
  right: 6px;
  background: none;
  border: none;
  font-size: 24px;
  color: #ccc;
  cursor: pointer;
}

.bookmarkCardBookmarkButton {
  position: absolute;
  top: 12px;
  right: 16px;
  background: none;
  border: none;
  font-size: 24px;
  color: #ccc;
  cursor: pointer;
}

.cardBookmarkIcon {
  transition:
    transform 120ms ease,
    color 160ms ease;
}

.cardBookmarkButton:hover,
.bookmarkCardBookmarkButton:hover {
  animation: bookmark-wiggle 180ms ease-out;
}

@keyframes bookmark-wiggle {
  0% {
    transform: rotate(0);
  }

  33% {
    transform: rotate(-10deg);
  }

  66% {
    transform: rotate(10deg);
  }

  100% {
    transform: rotate(0);
  }
}

.cardBookmarkButton:active .cardBookmarkIcon,
.bookmarkCardBookmarkButton:active .cardBookmarkIcon {
  transform: scale(0.85);
}

.cardBookmarkIcon.blue {
  color: #084b8a;
}

.cardBookmarkIcon.white {
  color: #ccc;
}
